// src/Zustand/AuthStore.js
import { create } from "zustand";
import axios from "axios";
import { MAIN_URL, getApiHeaders } from "../../Configurations/Urls";

const usePermissionDataStore = create((set) => ({
  Permission: [],
  setPermission: (data) => set({ Permission: data }),

  updatePermissionStore: (updatedList) =>
    set((state) => ({
      Permission: updatedList,
    })),

  /**
   * Refresh permissions for org-scoped or application-only sessions.
   * Pass organizationUserId and/or applicationUserId.
   */
  refreshPermissions: async (organizationUserId, applicationUserId = null) => {
    try {
      let allowed = [];

      if (organizationUserId) {
        const res = await axios.get(
          `${MAIN_URL}/api/user/${organizationUserId}/check-permission-access`,
          { headers: getApiHeaders() }
        );
        allowed = res?.data?.allowed_actions || [];
      } else if (applicationUserId) {
        const res = await axios.get(
          `${MAIN_URL}/api/application/user/${applicationUserId}/check-permission-access`,
          { headers: getApiHeaders() }
        );
        allowed = res?.data?.allowed_actions || [];
      } else {
        console.warn("User id is required to refresh permissions");
        return;
      }

      set({ Permission: allowed });
      return allowed;
    } catch (error) {
      console.error("Permission refresh error:", error);
      return null;
    }
  },
}));
export default usePermissionDataStore;
